import React, {forwardRef} from 'react';
import RiskReconMappingForm from './RiskReconMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';

function RiskReconCredentialsForm(props, ref){
    const fields = [
        {
            name: "apiEndpoint",
            label: "API EndPoint",
            required: false,
            rules:[urlRegexValidator],
            props: {
                defaultValue: "https://api.riskrecon.com"
            }
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ]
    return(
        <GenericPullCredentialsForm
        {...props}
        ref={ref}
        fields={fields}
        MappingForm={RiskReconMappingForm}
        />
    )
};

export default forwardRef(RiskReconCredentialsForm)